module.exports = __webpack_public_path__ + "static/depoimento 2-d1b40fb3b829a0c63618e9c3fd160f60.svg";